import { render, staticRenderFns } from "./SectionNewtork.vue?vue&type=template&id=2e22cd76&scoped=true&"
import script from "./SectionNewtork.vue?vue&type=script&lang=js&"
export * from "./SectionNewtork.vue?vue&type=script&lang=js&"
import style0 from "./SectionNewtork.vue?vue&type=style&index=0&id=2e22cd76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e22cd76",
  null
  
)

export default component.exports